import {TaxiLampEnum} from '@/models/digital-document-queue-sender-transfer-protocol-form-model';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function taxiLampTypeNameFilter(type: TaxiLampEnum) {
  switch (type) {
    case TaxiLampEnum.Wired: return i18n.t(LF.StandardWired) as string;
    case TaxiLampEnum.WirelessWithRemote: return i18n.t(LF.WirelessWithRemoteControl) as string;
    case TaxiLampEnum.BoltBranded: return 'Bolt';
    case TaxiLampEnum.UberBranded: return 'Uber';
    case TaxiLampEnum.FreeNowBranded: return 'FreeNow';

  }
}
